import { useUserContext } from 'Data/context/Users';
import { OBJECT_STATUS } from 'Data/Enum';
import GenericTableData from 'Data/GenericTableData';
import DataManager from 'Lib/DataManager';
import { useEffect, useRef, useState } from 'react';
import { getNameWithInactiveTag } from 'Util';

let DM = new DataManager();

export const useUserListData = ({
  userRoles,
  orgIds,
  excludedIds,
  includedId,
  showDeactivated = false,
}) => {
  const userDataRef = useRef(GenericTableData.getTableDataBus('USER', 'users'));
  const ThisUserData = userDataRef.current;

  const [userList, setUserList] = useState();

  const { getFilteredList } = useUserContext();

  useEffect(() => {
    DM.add(
      ThisUserData.registerListener('LIST_LOADED', onUserListLoaded),
      ThisUserData,
    );

    if (userRoles) {
      ThisUserData.getRecordList({
        where: {
          '*$user_roles.role': userRoles,
          '*status': OBJECT_STATUS.ACTIVE.key,
        },
        _sort: 'full_name',
        _pageSize: 1000,
      });
    }
  }, []);

  useEffect(() => {
    if (orgIds) {
      if (!Array.isArray(orgIds) || orgIds?.length) {
        ThisUserData.getRecordList({
          where: {
            '*$organizations.id': orgIds,
            '*status': OBJECT_STATUS.ACTIVE.key,
          },
          _sort: 'full_name',
          _pageSize: 1000,
        });
      }
    }
  }, [orgIds]);

  const onUserListLoaded = (payload) => {
    payload?.records?.length &&
      setUserList(
        payload.records.map((item) => {
          return {
            ...item,
            displayName: getNameWithInactiveTag(item, 'full_name'),
          };
        }),
      );
  };

  return getFilteredList({
    userList,
    useFullList: !orgIds && !userRoles,
    includedId,
    excludedIds,
    showDeactivated,
  });
};
